import { Locale, type LocalizedString } from "./Locale.js";

export enum PaymentStatus {
	Unpaid = "Unpaid",
	PaidPartially = "PaidPartially",
	Paid = "Paid",
	Refunded = "Refunded",
	AwaitingRefund = "AwaitingRefund",
}

export const paymentStatusNameMap: Record<PaymentStatus, LocalizedString> = {
	[PaymentStatus.Unpaid]: { [Locale.cs]: "Nezaplacená" },
	[PaymentStatus.PaidPartially]: { [Locale.cs]: "Částečně zaplacená" },
	[PaymentStatus.Paid]: { [Locale.cs]: "Zaplacená" },
	[PaymentStatus.Refunded]: { [Locale.cs]: "Vrácená" },
	[PaymentStatus.AwaitingRefund]: { [Locale.cs]: "Čeká na vrácení peněz" },
};
